import React, { Component } from 'react'

import Config from 'utils/config'

import ContentHeader from 'modules/Content/ContentHeader'
import FilterContainer from 'modules/Filters/FilterContainer'
import PanelSection from 'modules/Content/PanelSection'
import ContentChartWrapper from 'modules/Content/ContentChart/ContentChartWrapper'
import PanelDimensionContainer from 'modules/Content/ContentChart/PanelDimensionContainer'
import API from 'utils/api/api'
import APPURL from 'utils/app/urls'
import RegionTools from 'utils/regions/regionTools'
import IndicatorTools from 'utils/indicators/indicatorTools'

import Loading from 'components/Loading'
import Error from 'components/Error'


class ContentContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      layer: 1,
      loading: true,
      error: false
    }
  }

  componentDidMount() {
    document.getElementsByTagName('html')[0].classList.remove('ork-no-scroll')
    this.loadData()
    let url = this.props.history.location.pathname
    let layer = APPURL.getLayerFromURL(url)
    this.setState({ layer })
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.selectedRegionId !== prevProps.selectedRegionId) {
      this.loadData()
    }
  }

  loadData() {
    if (this.props.selectedRegionId === null) return
    const p1 = API.getRegions().then(regions => RegionTools.getDataFromRegions(regions))

    // if (Config.getConfig().app.USE_REFREGIONS) {
    //   const p2 = p1
    //     .then(regionsData => {
    //       return { regionsPromise: API.getReferenceRegions(regionsData, this.props.selectedRegionId), regionsData }
    //     })
    //     .then(({ regionsPromise, regionsData }) =>
    //       regionsPromise.then(regions =>
    //         RegionTools.getDataFromReferenceRegions({ regions, regionsData, selectedRegionId: this.props.selectedRegionId })
    //       )
    //     )
    // }

    const p3 = API.getRegions().then(regions => RegionTools.getSameCountryRegionsData(regions, this.props.selectedRegionId))

    const p4 = API.getIndicators().then(indicators => IndicatorTools.getDataFromIndicators(indicators))

    const p5 = API.getIndicatorsStatus().then(indicatorsStatus => indicatorsStatus.last_checked_on)

    const p6 = API.getCountries().then(countries => RegionTools.getDataFromCountries(countries))

    Promise.all([p1, /*p2,*/ p3, p4, p5, p6])
      .then(values => {
        this.props.setRegionsData(values[0])
        if (Config.getConfig().app.USE_REFREGIONS) {
          this.props.setReferenceRegionsData(values[1]);
          this.props.setSameCountryRegionsData(values[2]);
          this.props.setIndicatorsData(values[3]);
          this.props.setIndicatorsLastUpdated(values[4]);
          this.props.setCountriesData(values[5]);
        } else {
          this.props.setSameCountryRegionsData(values[1]);
          this.props.setIndicatorsData(values[2]);
          this.props.setIndicatorsLastUpdated(values[3]);
          this.props.setCountriesData(values[4]);
        }


        let selectedRegionMeta = values[0].filter(region => Number(region.id) === Number(this.props.selectedRegionId))[0]

        let selectedRegionCountryMeta = RegionTools.countryCodeToMeta(
          RegionTools.getCountryCodeFromRegionCode( selectedRegionMeta.code )
        )
        this.props.setSelectedRegionCountryMeta(selectedRegionCountryMeta);
      })
      .then(() => {
        this.setState({ loading: false, error: false })
      })
      .catch(reason => {
        this.setState({ error: true, loading: false })
      })
  }

  decide() {
    switch (this.state.layer) {
      case 1:
        return (
          <React.Fragment>
            <PanelSection layer={this.state.layer} dimension={0} collapsed={false} />
            <PanelSection layer={this.state.layer} dimension={1} collapsed={true} />
            <PanelSection layer={this.state.layer} dimension={2} collapsed={true} />
            <PanelSection layer={this.state.layer} dimension={3} collapsed={true} />
          </React.Fragment>
        )
      case 2:
        let level = this.props.match.params.level
        return (
          <React.Fragment>
            <PanelDimensionContainer layer={this.state.layer} dimension={level} />
          </React.Fragment>
        )
      case 3:
        let indicator = APPURL.getIndicatorFromURL(this.props.history.location.pathname)
        return (
          <React.Fragment>
            <ContentChartWrapper layer={this.state.layer} level={0} indicator={indicator} />
          </React.Fragment>
        )
      default:
        return ''
    }
  }

  renderIfAllOK() {
    let renderingComponent = null
    if (this.state.error) {
      renderingComponent = <Error />
    } else if (this.state.loading) {
      renderingComponent = <Loading />
    } else {
      let layer = this.state.layer;
      let dimension;
      let indicatorId;
      if ( layer === 3 ) {
        indicatorId = Number( this.props.match.params.indicatorId );
        dimension = IndicatorTools.getDimensionFromIndicator( indicatorId );
      } else {
        dimension = this.props.match.params.level
        indicatorId = 0;
      }

      let contentClass = `obs-panel-${dimension}`;

      let filterContainer = null;
      if ( layer > 1 ) {
        filterContainer = <React.Fragment>
            <FilterContainer layer={this.state.layer} typeAheadMultiple={this.state.layer === 1 ? false : true} />
          </React.Fragment>;
      }
      renderingComponent = (
        <React.Fragment>
          <div className={contentClass}>
          <ContentHeader layer={this.state.layer} level={dimension} indicator={indicatorId} />
          {filterContainer}
          {this.decide()}
          </div>
        </React.Fragment>
      )
    }
    return renderingComponent
  }

  render() {
    return <div className="container-fluid ork-gray-box">{this.renderIfAllOK()}</div>
  }
}

export default ContentContainer



// WEBPACK FOOTER //
// ./src/modules/Content/ContentContainer/ContentContainer.jsx